// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.listingconversation.RentalManagerUserListingConversationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  MultiBrandSupportConversationStatusUpdateRequestDto,
  RentalManagerUserListingConversationCachedConversationCountsResponseWebDto,
  RentalManagerUserListingConversationGetConversationCountsForListingResponseWebDto,
} from '../..';

interface GetConversationCountsForListingParams {
  calculateInRealTime?: boolean;
  listingAlias: ListingAlias;
}

export const RentalManagerUserListingConversationWebApiHandler_cachedConversationCounts_Path =
  '/api/web/v1/users/listingConversation/cachedConversationCounts';

/**
 * Get cached conversation counts for the last 90 days
 */
export const RentalManagerUserListingConversationWebApiHandler_cachedConversationCounts = (client = getClient()) => {
  return httpFrontEndRequest<never, never, RentalManagerUserListingConversationCachedConversationCountsResponseWebDto>(
    {
      endpoint: RentalManagerUserListingConversationWebApiHandler_cachedConversationCounts_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_Path =
  '/api/web/v1/users/listingConversation/getConversationCountsForListing';

/**
 * Get cached conversation counts for the last 90 days for this listing
 */
export const RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing = (
  getParams: GetConversationCountsForListingParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<
    GetConversationCountsForListingParams,
    never,
    RentalManagerUserListingConversationGetConversationCountsForListingResponseWebDto
  >(
    {
      getParams: getParams,
      endpoint: RentalManagerUserListingConversationWebApiHandler_getConversationCountsForListing_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserListingConversationWebApiHandler_updateStatus_Path =
  '/api/web/v1/users/listingConversation/updateStatus';

/**
 * Update status of a conversation
 */
export const RentalManagerUserListingConversationWebApiHandler_updateStatus = (
  postData: MultiBrandSupportConversationStatusUpdateRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, MultiBrandSupportConversationStatusUpdateRequestDto, void>(
    {
      endpoint: RentalManagerUserListingConversationWebApiHandler_updateStatus_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
